import { MASTER_DATA_DONE } from "../../action/master";

const initState = {
    data: [],
    error: null,
    status: null,
    currentlogedInuser: null,
};

export const masterReducer = (state = initState, action) => {
    switch (action.type) {
        case MASTER_DATA_DONE:
            return {
                ...state,
                masterData: {
                    data: action?.payload?.data,
                    status: action?.payload?.data?.status,
                    error: null,
                },
            };
        default:
            return state;
    }
};
